import React, { useEffect } from 'react';
import './App.css';
import { trackPageView } from './firebase';
import Header from './components/Header';
import Hero from './components/Hero';
import Gallery from './components/Gallery';
import PerfectionQuote from './components/PerfectionQuote';
import Talleres from './components/Talleres';
import About from './components/About';
import Quote from './components/Quote';
import RinconesEncanto from './components/RinconesEncanto';
import Footer from './components/Footer';

function App() {
  useEffect(() => {
    // Track initial page view
    trackPageView('home');
  }, []);

  return (
    <div className="App">
      <Header />
      <Hero />
      <Gallery />
      <PerfectionQuote />
      <Talleres />
      <About />
      <RinconesEncanto />
      <Quote />
      <Footer />
    </div>
  );
}

export default App;
